import { TreePine, ShieldCheck, Route, Zap, Droplets, Building2, Camera, Sparkles, Users, Dumbbell } from "lucide-react";

const ITEMS = [
  { icon: ShieldCheck, t: "24×7 Security", d: "Manned gate, CCTV surveillance and patrolling for a worry-free community." },
  { icon: TreePine, t: "Parks & Greenbelt", d: "Landscaped central park and tree-lined avenues throughout the layout." },
  { icon: Route, t: "50 ft Wide Main Road", d: "A grand 50-ft main approach road with proper kerbs, drainage and street lighting." },
  { icon: Zap, t: "Underground Power", d: "Buried electrical lines for an uncluttered skyline and uninterrupted service." },
  { icon: Droplets, t: "Water Supply", d: "Tubewell + overhead tank network with individual metered connections." },
  { icon: Building2, t: "Clubhouse Zone", d: "Community space planned for gatherings, fitness and indoor games." },
  { icon: Camera, t: "CCTV Surveillance", d: "Strategic cameras at all access points and common areas." },
  { icon: Sparkles, t: "Solar Street Lighting", d: "Energy-efficient solar lights line every avenue and park edge." },
  { icon: Users, t: "Children's Play Area", d: "Dedicated safe-play zones with modern, child-friendly equipment." },
  { icon: Dumbbell, t: "Open Gym", d: "Outdoor fitness equipment for residents of every age group." },
];

export default function Amenities() {
  return (
    <div className="bg-[#0a0a0b] text-white pt-32">
      <section className="max-w-7xl mx-auto px-6 lg:px-12 py-16" data-testid="amenities-hero">
        <p className="label-overline">Amenities</p>
        <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl mt-5 tracking-tight leading-[1.05] max-w-4xl">
          Designed for daily delight, <br /><span className="italic text-[#c5a059]">priced for lasting value</span>.
        </h1>
        <p className="text-[#cfcfd2] mt-8 max-w-2xl leading-relaxed">
          From the moment you turn off the highway and pass through our gates, every detail is curated
          to make plotted living feel premium — without overcomplicating things.
        </p>
      </section>

      <section className="bg-[#08080a] border-y border-[#1f1f22] py-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-px bg-[#1f1f22]" data-testid="amenities-grid">
          {ITEMS.map(({ icon: Icon, t, d }) => (
            <div key={t} className="bg-[#0a0a0b] p-8 card-hover hover:bg-[#0f0f11]">
              <Icon size={28} className="text-[#c5a059]" strokeWidth={1.4} />
              <h3 className="font-serif text-xl mt-5">{t}</h3>
              <p className="text-xs text-[#8f8f94] mt-3 leading-relaxed">{d}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-12 py-24 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6">
          <img
            src="https://images.unsplash.com/photo-1626456877396-5af019036c63?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
            alt="Green park within the layout"
            className="rounded-xl w-full"
          />
        </div>
        <div className="lg:col-span-6">
          <p className="label-overline">Greenery First</p>
          <h2 className="font-serif text-4xl md:text-5xl mt-4 tracking-tight">30% of every layout, returned to nature.</h2>
          <p className="text-[#cfcfd2] mt-6 leading-relaxed">
            Walking trails, shaded benches, native trees, and seasonal flowering — our parks
            are designed by landscape architects, not as afterthoughts but as the soul of the community.
          </p>
        </div>
      </section>
    </div>
  );
}
